import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const CookieBanner = () => {
  const [show, setShow] = useState(() => !localStorage.getItem("lgt_cookie_notice"));
  if (!show) return null;
  const accept = () => {
    localStorage.setItem("lgt_cookie_notice", "1");
    setShow(false);
  };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-50 bg-[#14161A]/95 backdrop-blur-xl border border-white/10 p-5 text-sm text-slate-300 shadow-2xl" data-testid="cookie-banner">
      <p>
        Questo sito utilizza solo cookie tecnici necessari al funzionamento. La mappa esterna viene caricata solo su tua richiesta.{" "}
        <Link to="/cookie" className="text-white underline underline-offset-4">Cookie Policy</Link>
      </p>
      <button onClick={accept} className="mt-4 bg-[#E50914] hover:bg-[#C10710] text-white px-5 py-2 text-xs font-bold uppercase tracking-wider transition-colors" data-testid="cookie-accept-btn">
        Ho capito
      </button>
    </div>
  );
};

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0C0E]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
